<template>

  <div class="p-3" style="background-color: #EEEEEE">
    <table class="vy-search-form-table-nav">
            <!-- フリーワード -->
            <tr>
              <th>
                <label for="keyword">フリーワード</label>
              </th>
              <td style="text-align: left;">
                <input type="text" placeholder="プログラム名、受入先、会場情報、活動内容、備考" class="form-control" id="keyword0" name="keyword0" v-model="keyword0">
                
              </td>
            </tr>
          
          <!-- 場所（分類1） -->
          <tr>
              <th class="smart_list" colspan="2">
                <label for="bunrui1">分類1</label>
                <select class="form-control" name="bunrui10" id="bunrui10" v-model="bunrui10" v-on:change="bunrui1_change()" >
                  <option value="全て">全て</option>
                  <option v-for:="(bunrui1_row,i) in bunrui1_list" v-bind:value="bunrui1_row">{{i+1}}．{{ bunrui1_row }}</option>
                </select>
              </th>
            </tr>

            <tr>
              <th class="smart_list" colspan="2">
                <label for="bunrui2">分類2</label>
              
                <select class="form-control" name="bunrui20" id="bunrui20" v-model="bunrui20" >
                  <option value="全て">全て</option>
                  <option v-for:="(bunrui2_row,i) in bunrui2_list_Extract" v-bind:value="bunrui2_row">{{i+1}}．{{ bunrui2_row }}</option>
                </select>
              </th>
            </tr>

            <tr>
              <th class="smart_list" colspan="2">
                <label for="shimekiri">申込受付</label>
              
                <select class="form-control" name="shimekiri0" id="shimekiri0" v-model="shimekiri0" >
                  <option value="0">全て</option>
                  <option value="1">受付中のみ</option>
                  <option value="2">受付終了のみ</option>
                </select>
              </th>
            </tr>
      
      <!-- 日程 -->
      <tr>
        <th class="smart_list" colspan="2">
          <label for="kaisai_date">開催日</label><input type="date" class="form-control" id="kaisai_date_start" name="kaisai_date_start" v-model="kaisai_start0" >
        </th>
      </tr>
      <!-- 対象者 -->
      <tr>
        <th>
          <label for="shokugyo">参加条件</label>
        </th>
        <th>
          <div class="form-group mb-3">
            <div class="form-check form-check-inline" style="display:flex;align-items:center">
              <input type="checkbox" class="form-check-input" id="joken_all" name="joken_all" value="すべてを選択／解除" checked="checked" v-on:click="All_joken()" v-model="joken_all0">
              <label class="form-check-label" for="joken_all">すべてを選択／解除</label>
            </div>
          </div>
                <div class="form-group mb-3">
                  <div class="form-check form-check-inline joken_div" v-if="gakusei_kbn_list[0] != '0'">
                    <input type="checkbox" class="form-check-input" id="joken1" name="joken[]" value="1" checked="checked" v-model="joken0" v-on:change="Check()" >
                    <label class="form-check-label" for="joken1">{{gakusei_meisho_list[0]}}</label>
                  </div>
                  <div class="form-check form-check-inline joken_div" v-if="gakusei_kbn_list[1] != '0'">
                    <input type="checkbox" class="form-check-input" id="joken2" name="joken[]" value="2" checked="checked" v-model="joken0" v-on:change="Check()" >
                    <label class="form-check-label" for="joken2">{{gakusei_meisho_list[1]}}</label>
                  </div>
                  <div class="form-check form-check-inline joken_div" v-if="gakusei_kbn_list[2] != '0'">
                    <input type="checkbox" class="form-check-input" id="joken3" name="joken[]" value="3" checked="checked" v-model="joken0" v-on:change="Check()" >
                    <label class="form-check-label" for="joken3">{{gakusei_meisho_list[2]}}</label>
                  </div>
                  <div class="form-check form-check-inline joken_div" v-if="gakusei_kbn_list[3] != '0'">
                    <input type="checkbox" class="form-check-input" id="joken4" name="joken[]" value="4" checked="checked" v-model="joken0" v-on:change="Check()" >
                    <label class="form-check-label" for="joken4">{{gakusei_meisho_list[3]}}</label>
                  </div>
                  <div class="form-check form-check-inline joken_div" v-if="gakusei_kbn_list[4] != '0'">
                    <input type="checkbox" class="form-check-input" id="joken5" name="joken[]" value="5" checked="checked" v-model="joken0" v-on:change="Check()" >
                    <label class="form-check-label" for="joken5">{{gakusei_meisho_list[4]}}</label>
                  </div>
                  <div class="form-check form-check-inline joken_div" v-if="gakusei_kbn_list[5] != '0'">
                    <input type="checkbox" class="form-check-input" id="joken6" name="joken[]" value="6" checked="checked" v-model="joken0" v-on:change="Check()" >
                    <label class="form-check-label" for="joken6">{{gakusei_meisho_list[5]}}</label>
                  </div>
                  <div class="form-check form-check-inline joken_div" v-if="gakusei_kbn_list[6] != '0'">
                    <input type="checkbox" class="form-check-input" id="joken7" name="joken[]" value="7" checked="checked" v-model="joken0" v-on:change="Check()" >
                    <label class="form-check-label" for="joken7">{{gakusei_meisho_list[6]}}</label>
                  </div>
                  <div class="form-check form-check-inline joken_div">
                    <input type="checkbox" class="form-check-input" id="joken8" name="joken[]" value="8" checked="checked" v-model="joken0" v-on:change="Check()" >
                    <label class="form-check-label" for="joken8">一般</label>
                  </div>
                </div>
          </th>
        </tr>
      </table>
    </div>
    
    <!-- 専用ボタン（フローティングメニューの上に配置） -->
<div class="vy-responsive-menu-container" style="
    margin-bottom: 50px;
    padding: 10px 0;
    background: rgba(0, 0, 0, .5);
    border: 0px;
    display: flex;
    justify-content: space-evenly;">
   <button class="btn btn-primary mx-aut" style="width: 45%; height: 50px;padding: 0;margin-right:10px;background-color: white;color:#4175d0;border:1px solid #000"  v-on:click="home()">戻る</button>
   <button class="btn btn-primary mx-aut" style="width: 45%; height: 50px;padding: 0" v-on:click="Check()">検索</button>
  
</div>

        
    <!--メッセージを表示するモーダルウィンドウ-->
    <component v-bind:is="contentMessage"
                v-bind:message_text="message"
                v-bind:message_cat="message_cat"
                v-bind:message_flag="message_flag"
                @close_message="Close_message"
                @ok_message="OK_message"/>
</template>

<script setup>
/* eslint-disable */
/* メッセージを表示するモーダルウィンドウ */
import MessageModal from '../common/MessageModal.vue'  
let message = ref("")//表示するメッセージ
let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
let message_flag = ref(false)//表示・非表示フラグ
/* 表示する子コンポーネント関係の情報 */
const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
contentMessage.value = null // 表示する子コンポーネント



import { useRouter } from 'vue-router'
const router = useRouter();
import { ref } from 'vue'
const props = defineProps(['param']);
const emit = defineEmits(['call'])

let cityname = props.param.cityname


// 親コンポーネント（User.vue）から送られてきた値
// bunrui1 ：体験プログラム全体の「分類1」の配列（「Taiken_get」APIから取得したもの）
// bunrui2 ：体験プログラム全体の「分類2」の配列（「Taiken_get」APIから取得したもの）
// gakusei_kbn_list,gakusei_meisho_list：学生区分に関する設定項目

// 検索条件
  // プルダウンメニューに表示する値を配列として格納
  let bunrui1_list = ref([])
  let bunrui2_list = ref([])

  // 参加条件（学生区分）
  let gakusei_kbn_list = props.param.gakusei_kbn_list
  let gakusei_meisho_list = props.param.gakusei_meisho_list

  let all_bunrui_list = props.param.all_bunrui_list

  // 分類1を格納
  for(let b1 = 0;b1<all_bunrui_list.length;b1++){
    let chohuku_flg1 = 0 // 重複してたら格納しない
    if(all_bunrui_list[b1].bunrui == 1){

      for(let b = 0;b<bunrui1_list.value.length;b++){

        console.log(all_bunrui_list[b1]["name"]+"/"+bunrui1_list.value[b])
        // 同じ名前がすでに格納されている場合
        if(all_bunrui_list[b1]["name"] ==  bunrui1_list.value[b]){

          // 重複フラグを立てる
          chohuku_flg1 = 1;

        }
      }

      // 重複してなければ追加
      if(chohuku_flg1 == 0){
        bunrui1_list.value[bunrui1_list.value.length] = all_bunrui_list[b1]["name"]
      }
    }
  }
  
  console.log(bunrui1_list.value)
  // 分類2を格納
  for(let b2 = 0;b2<all_bunrui_list.length;b2++){
    if(all_bunrui_list[b2].bunrui == 2){
      console.log(all_bunrui_list[b2])

      let bunrui1_ok = 0 // この分類2が所属する分類1が存在するなら追加する
      // 分類1を回す
      for(let b1 = 0 ;b1<bunrui1_list.value.length;b1++){
        if(all_bunrui_list[b2].bunrui1_name == bunrui1_list.value[b1]){
          bunrui1_ok = 1
        }
      }
      console.log(bunrui1_ok)
      if(bunrui1_ok == 1){
        
        let chohuku_flg = 0
        for(let b2l = 0;b2l<bunrui2_list.value.length;b2l++){
          if(bunrui2_list.value[b2l]["name"] == all_bunrui_list[b2]["name"]){
            chohuku_flg = 1
          }
        }
        if(chohuku_flg == 0){
          bunrui2_list.value[bunrui2_list.value.length] = all_bunrui_list[b2]
        }
      }
    }
  }
  // 分類1によって絞り込まれた分類2のリスト
  let bunrui2_list_Extract = ref([])
  
  let bunrui10 = ref("全て") // 分類1
  let bunrui20 = ref("全て") // 分類2
  let shimekiri0 = ref(0) // 申込受付
  let kaisai_start0 = ref("") // 日程（自）
  let joken0 = ref(["1","2","3","4","5","6","7","8"]) // 対象者（参加条件）　1：小学、2：中学、3：高校、4：高専、5：専門、6：大学、7：大学院、8：その他

//let joken0 = ref(["1","2","3","6","8"]) // 対象者（参加条件）　1：小学、2：中学、3：高校、6：専門・大学、8：その他
  let keyword0 = ref("") // フリーワード
  // チェックボックス全選択切り替え
  let joken_all0 = true // 対象者（参加条件）


//検索を開始する
let Check = function(){ 

  if(joken0.value.length == 0){
    
    message.value = "「参加条件」は、必ず１つ選択してください。";
    message_cat.value = 0;
    message_flag.value = true;
    message_method.value = "joken_error";
    contentMessage.value = MessageModal
  }else{
    router.replace("/"+cityname+"/Taiken")
    //  親コンポーネントへ検索条件を送信する
    emit('call',{cmd:'search',
                bunrui10:bunrui10.value,
                bunrui20:bunrui20.value,
                keyword0:keyword0.value,
                kaisai_date0:kaisai_start0.value,
                joken0:joken0.value,
                shimekiri0:shimekiri0.value});
  }
}
  
/* その他関数の記述 */
// 「対象者（参加条件）」の「すべてを選択／解除」をクリックした時の処理
let All_joken = function(){
    if(joken_all0 == true){
        joken_all0 = false
        joken0.value = []
    } else {
        joken_all0 = true
        joken0.value = ["1","2","3","4","5","6","7","8"]
    
    }
}
//------------------------------ リンク --------------------------------
const home = function() {
    //document.getElementById("vy_responsive_menu_close").click();
    emit('call', { cmd:'return_smart',id:''})
}

 
  // 分類1を変更したとき、分類2を絞り込む
  let bunrui1_change = function(){

    // 現在選択中の分類2は全てに戻す
    bunrui20.value = "全て"
    bunrui2_set()
  }

// 分類2を絞り込む処理
let bunrui2_set = function(){

  // 表示する分類2リストを初期化
  bunrui2_list_Extract.value = []

  // 分類1が全てなら、分類2も全て格納する
  if(bunrui10.value == "全て"){

    for(let b2 = 0;b2<bunrui2_list.value.length;b2++){
        bunrui2_list_Extract.value[b2] = bunrui2_list.value[b2]["name"]
    }

  }else{

    let ex_count = 0;//表示する分類2の数
    for(let b2 = 0;b2 < all_bunrui_list.length;b2++){
      if(all_bunrui_list[b2].bunrui == 2){
        // 分類1が「全て」以外の場合は、その分類1に所属する分類2を表示する
        // 分類1が「全て」の場合は、同じく全ての分類2を表示する
        if(bunrui10.value == all_bunrui_list[b2]["bunrui1_name"] || bunrui10.value == "全て"){
          bunrui2_list_Extract.value[ex_count] = all_bunrui_list[b2]["name"]
          ex_count = ex_count + 1

        }
      }
    }
  }

}

    // メッセージを表示するウィンドウでOKを押された時
    let OK_message = function(){ 
        Close_message();//メッセージを表示するウィンドウを閉じる

      //個別処理は現状なし
    }

    // メッセージを表示するウィンドウを閉じる
    let Close_message = function(){
        message_flag.value = false;
        contentMessage.value = null
    }


  
  /* 初期処理 */
  // 一度でも検索したことがある場合は既存の検索を挿入する
  if(props.param.search_param != {}){


    let search_param = props.param.search_param 

    if(search_param.bunrui1) bunrui10.value = search_param.bunrui1
    if(search_param.bunrui2) bunrui20.value = search_param.bunrui2
    if(search_param.shimekiri) shimekiri0.value = search_param.shimekiri
    if(search_param.kaisai_date) kaisai_start0.value = search_param.kaisai_date
    if(search_param.joken) joken0.value = search_param.joken
    if(search_param.keyword) keyword0.value = search_param.keyword

    bunrui2_set()
  }

  emit('call', { cmd:'page_scroll'})


</script>
<style scoped>


.smart_list{

  display: flex;
  align-items: center;
  justify-content: space-between;

}

.smart_list input,
.smart_list select{
  width:70%
}

.form-row{
  display: flex;
}

.form-row div{
  width:40%;
  display: flex;
  align-items:center;
}

.form-check-input{
  margin-right:10px;
  width:25px;
  height:25px
}

.form-control{
  font-size: 0.9rem;
}

.joken_div{
  display: flex;
  align-items: center;
}

</style>


